import * as React from "react";
import { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import TableHomescreen from "../../containers/TableHomescreen/TableHomescreen";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import DashboardSharpIcon from "@mui/icons-material/DashboardSharp";
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Dashboard from "../Dashboard/Dashboard";
import PersonalPatientFileScreen from "../../containers/PersonalPatientFileScreen/PersonalPatientFileScreen";
import BallotIcon from "@mui/icons-material/Ballot";
import PatientList from "../../containers/patientlist/PatientList";
import PersonalPatientFile from "../PersonalPatientFile/PersonalPatientFile";
// import Navbar from "../navbar/Navbar";
import Navbar from "../Navbar/Navbar";
import { GiDirectionSign } from "react-icons/gi";
import { BsFillBagCheckFill, BsBell } from "react-icons/bs";
import { FaAngleDown } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import AddPatient from "../AddPatient/AddPatient";
import Questionnaire from "../Questionnaire/Questionnaire";
import Login from "../Login/Login";
import PatientQuestionnaire from "../PatientQuestionnaire/PatientQuestionnaire";
import PatientDashboard from "../PatientDashboard/PatientDashboard";
import ProductDetails from "../ProductDetails/ProductDetails";
import AccountSetting from "../AccountSetting/AccountSetting";
import PatientAccountSetting from "../PatientAccountSetting/PatientAccountSetting";
import Icon from "../../Images/Icon";
import ClinicHomePage from "../ClinicHomePage/ClinicHomePage";
import ClinicDashboard from "../ClinicDashboard/ClinicDashboard";
import AppointmentbyClinic from "../AppointmentbyClinic/AppointmentbyClinic";
import ClinicHomePageNew from "../ClinicHomePage/ClinicHomePageNew";
import ClinicDoctorList from "../ClinicDoctorList/ClinicDoctorList";
import ClinicPatientList from "../ClinicPatientList/ClinicPatientList";
// import ReactWhatsapp from "react-whatsapp";
import { BsWhatsapp } from "react-icons/bs";
import BlogMainPage from "../BlogMainPage/BlogMainPage";
import DoctorBlog from "../DoctorBlog/DoctorBlog";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import AppointmentList from "../AppointmentList/AppointmentList";
// import WebCam from "../WebCam/WebCam";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import EventByClinic from "../EventByClinic/EventByClinic";
import QuestionnaireNew from "../Questionnaire/QuestionnaireNew";
import PatientViewForDoctor from "../PatientViewForDoctor/PatientViewForDoctor";
import DoctorRegistration from "../DoctorRegistration/DoctorRegistration";
import SubClinicRegistration from "../ClinicSignup/SubClinicRegistration";
import ReceptionistRegistration from "../ReceptionistRegistration/ReceptionistRegistration";
import DoctorPrescription from "../DoctorPrescription/DoctorPrescription";
import ClinicPatientPrescription from "../ClinicPatientPrescription/ClinicPatientPrescription";
import ClinicDoctorDetails from "../ClinicDoctorDetails/ClinicDoctorDetails";
import SubClinicList from "../SubClinicList/SubClinicList";
import ClinicDocuments from "../ClinicDocuments/ClinicDocuments";
import ClinicPrescriptionCard from "../ClinicPrescriptionCard/ClinicPrescriptionCard";
import SubClinicDetailsHomePage from "../SubClinicDetailsHomePage/SubClinicDetailsHomePage";
import SubClinicPatientList from "../ClinicPatientList/SubClinicPatientList";
import SubClinicDoctorList from "../ClinicDoctorList/SubClinicDoctorList";
import SubClinicReceptionistList from "../SubClinicReceptionistList/SubClinicReceptionistList";
import DoctorExtraDetails from "../DoctorExtraDetails/DoctorExtraDetails";
import SubClinicAppointmentList from "../AppointmentList/SubClinicAppointmentList";
import ReceptionistExtraDetails from "../ReceptionistExtraDetails/ReceptionistExtraDetails";
import ClinicReceptionistList from "../ClinicReceptionistList/ClinicReceptionistList";
import Notification from "../Notification/Notification";
import SubClinicExtraDetails from "../ClinicSignup/SubClinicExtraDetails";
import AppontmentbyClinicHomePage from "../AppointmentbyClinic/AppontmentbyClinicHomePage";
import ClinicDietitianList from "../DietitianList/ClinicDietitianList";
import DietitianRegistration from "../DietitianRegistration/DietitianRegistration";
import DietitianExtraDetails from "../DietitianExtraDetails/DietitianExtraDetails";
import TrainerRegistration from "../TrainerRegistration/TrainerRegistration";
import TrainerExtraDetails from "../TrainerRegistration/TrainerExtraDetails";
import ClinicTrainerList from "../ClinicTrainerList/ClinicTrainerList";
import AppointmentListHomePage from "../AppointmentList/AppointmentListHomePage";
import TermsandConditions from "../TermsandConditions/TermsandConditions";
import PrivacyPolicy from "../TermsandConditions/PrivacyPolicy";
import AccessibilityPolicy from "../TermsandConditions/AccessibilityPolicy";
import UserData from "../UserData/UserData";
import MarketingMailbyClinicSubClinic from "../Mail/MarketingMailbyClinicSubClinic/MarketingMailbyClinicSubClinic";
import EmailIcon from "@mui/icons-material/Email";
import NewNavbar from "../NewNavbar/NewNavbar";
import ClinicServiseProviderList from "../ClinicServiseProviderList/ClinicServiseProviderList";
import MailHomePage from "../Mail/MailHomePage/MailHomePage";
// import DirectChatPage from "../Chat/ChatEngine";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import Chat from "../Chat/ChatTest";
import PatientResponseAnalysis from "../PatientQuestionnaire/PatientResponseAnalysis";
import CustomerSuccessByClinic from "../CustomerSuccessDashboard/CustomerSuccessDashboardbyClinic";
import DoctorCreateBlog from "../DoctorCreateBlog/DoctorCreateBlog";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  overflow: "hidden",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  overflow: "hidden",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(3.5)} + 2px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(5)} + 1px)`,
  },
});


const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  height: 1,
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function ClinicSidebar() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [openPlan, setOpenPlan] = React.useState(true);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const URL = window.location.href;

  const navigatetwo = useNavigate();

  const navigateFunction = () => {
    if (URL !== "http://localhost:3000/clinicdashboard" && URL !== "http://localhost:3000/clinicdashboard") {
    navigatetwo(-1);
  }
}
  

  const [opentwo, setOPentwo] = useState(false);
  const toggletwo = () => {
    setOPentwo(!opentwo);
  };

  const [openthree, setOPenthree] = useState(false);
  const togglethree = () => {
    setOPenthree(!openthree);
  };
  const handleClick = () => {
    setOpen(!open);
  };

  const handleClickPlan = () => {
    setOpenPlan(!openPlan);
  };
  const handleDrawerOpen = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(!drawerOpen);
  };

  const loginpage = () => {
    navigate("/");
  };

  const navigate = useNavigate();

  const UserInfo = localStorage.getItem("Username");
  const patientUsername = localStorage.getItem("patientUserName");

  const [onlineUsers, setOnlineUsers] = useState([]);

  useEffect(() => {
    const fetchOnlineUsers = async () => {
      const response = await fetch(
        "https://djangoobesitychat.azurewebsites.net/chat/api/online_users/",
        { headers: { Authorization: `Token ${localStorage.getItem("SavedToken")}` } }
      );
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }
      const data = await response.json();
      setOnlineUsers(data);
    };
    fetchOnlineUsers();
  }, []);

  // CHECK THE USERTPYE IS CLINIC OR NOT
  const [authenticated, setauthenticated] = useState(null);
  useEffect(() => {
    const loggedInUser =
      localStorage.getItem("is_clinic") === "true" ||
      localStorage.getItem("is_receptionist") === "true";
    if (loggedInUser) {
      setauthenticated(loggedInUser);
    }
  }, []);
  if (!authenticated) {
    return (
      <div>
        <h1>Please Login</h1>
        <button> Login</button>
      </div>
    );
  } else
    return (
      <div>
        <Box sx={{ display: "flex", overflow: "hidden" }}>
          <CssBaseline />

          {/* NAVBAR COMPONENT */}
          <NewNavbar />

          <div></div>

          {/* CLINIC SIDEBAR CODE */}

          <Drawer
            sx={{ "& .MuiDrawer-paper": { backgroundColor: "#252b4a" } }}
            variant="permanent"
            open={drawerOpen}
          >
            <DrawerHeader>
              <IconButton
                style={{ color: "#ffffff", fontSize: 19, borderRadius: "1%" }}
                onClick={handleDrawerClose}
              >
                {theme.direction === "ltr" ? (
                  <GiHamburgerMenu />
                ) : (
                  <GiHamburgerMenu />
                )}
              </IconButton>
            </DrawerHeader>
            <Divider />
            <List>
              <ListItem
                key="Go Back"
                disablePadding
                sx={{ display: "block" }}
                onClick={navigateFunction}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 3,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 1.4,
                      justifyContent: "center",
                    }}
                  >
                    <ArrowBackIcon style={{ color: "#ffffff" }} />
                  </ListItemIcon>
                  <ListItemText
                    primary="Go Back"
                    style={{ color: "#ffffff" }}
                  />
                </ListItemButton>
              </ListItem>

              <ListItem
                key="Dashboard"
                disablePadding
                sx={{ display: "block" }}
              >
                <Link to="/clinicsidebar">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 3,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 1.4,
                        justifyContent: "center",
                      }}
                    >
                      <DashboardSharpIcon style={{ color: "#ffffff" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Dashboard"
                      style={{ color: "#ffffff" }}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>

              <ListItem
                key="patientList"
                disablePadding
                sx={{ display: "block" }}
              >
                <Link to="/clinicsidebar/blogmainpage">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 3,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 1.4,
                        justifyContent: "center",
                      }}
                    >
                      <TextSnippetIcon style={{ fill: "#ffffff" }} />
                    </ListItemIcon>
                    <ListItemText primary="Blog" style={{ color: "#ffffff" }} />
                  </ListItemButton>
                </Link>
              </ListItem>

              <ListItem
                key="patientList"
                disablePadding
                sx={{ display: "block" }}
              >
                <Link to="/clinicsidebar/chat/obesity/">
                  <ListItemButton
                    onClick="window.location.href=window.location.href"
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 3,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 1.4,
                        justifyContent: "center",
                      }}
                    >
                      <MessageOutlinedIcon style={{ fill: "#ffffff" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Messenger"
                      style={{ color: "#ffffff" }}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>

              <ListItem
                key="patientList"
                disablePadding
                sx={{ display: "block" }}
              >
                <Link to="/clinicsidebar/marketingmail">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 3,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 1.4,
                        justifyContent: "center",
                      }}
                    >
                      <EmailIcon style={{ fill: "#ffffff" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Marketing Mail"
                      style={{ color: "#ffffff" }}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem
                key="patientList"
                disablePadding
                sx={{ display: "block" }}
              >
                <Link to="/clinicsidebar/customersuccess">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 3,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 1.4,
                        justifyContent: "center",
                      }}
                    >
                      <DashboardCustomizeIcon style={{ fill: "#ffffff" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Marketing Mail"
                      style={{ color: "#ffffff" }}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>

              {!open ? (
                <div
                  style={{ position: "relative", valign: "bottom", top: "80%" }}
                >
                  <ListItem
                    key="Privacy Policy"
                    disablePadding
                    sx={{ display: "block", valign: "bottom" }}
                  >
                    <Link to="/clinicsidebar/privacypolicy">
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 3,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 20,
                            mr: open ? 3 : 1.4,
                            justifyContent: "center",
                          }}
                        ></ListItemIcon>
                        <ListItemText
                          primary="Privacy Policy"
                          style={{ color: "#ffffff" }}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>

                  <ListItem
                    key="Terms & Conditions"
                    disablePadding
                    sx={{ display: "block", bottom: "0" }}
                  >
                    <Link to="/clinicsidebar/termsandconditions">
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 3,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 20,
                            mr: open ? 3 : 1.4,
                            justifyContent: "center",
                          }}
                        ></ListItemIcon>
                        <ListItemText
                          primary="Terms & Conditions"
                          style={{ color: "#ffffff" }}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>

                  <ListItem
                    key="Accessibility Policy"
                    disablePadding
                    sx={{ display: "block", bottom: "0" }}
                  >
                    <Link to="/clinicsidebar/accessibilitypolicy">
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 3,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 20,
                            mr: open ? 3 : 1.4,
                            justifyContent: "center",
                          }}
                        ></ListItemIcon>
                        <ListItemText
                          primary="Accessibility Policy"
                          style={{ color: "#ffffff" }}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                </div>
              ) : (
                <p></p>
              )}
            </List>
          </Drawer>


          {/* CLINIC ROUTES PATH */}

          <Box component="main" open={open}>
            <DrawerHeader />
            <Routes>
              <Route path="/" element={<ClinicHomePage />} />
              <Route path="/clinicdashboard" element={<ClinicDashboard />} />
              <Route
                path="/clinicpatientlist"
                element={<ClinicPatientList />}
              />

              <Route path="/clinicdoctorlist" element={<ClinicDoctorList />} />
              <Route
                path="/clinicserviseproviderlist"
                element={<ClinicServiseProviderList />}
              />
              <Route
                path="/subclinicregistration"
                element={<SubClinicRegistration />}
              />
              <Route
                path="/subclinicextradetails"
                element={<SubClinicExtraDetails />}
              />
              <Route
                path="/receptionistregistration"
                element={<ReceptionistRegistration />}
              />
              <Route
                path="/receptionistextradetails"
                element={<ReceptionistExtraDetails />}
              />
              <Route
                path="/trainerregistration"
                element={<TrainerRegistration />}
              />
              <Route
                path="/trainerextradetails"
                element={<TrainerExtraDetails />}
              />
              <Route
                path="/clinicreceptionistlist"
                element={<ClinicReceptionistList />}
              />
              <Route
                path="/prescriptionbydoctorclinicview"
                element={<ClinicPatientPrescription />}
              />
              <Route
                path="/prescriptioncliniccard"
                element={<ClinicPrescriptionCard />}
              />
              <Route
                path="/appointmentbyclinic"
                element={<AppontmentbyClinicHomePage />}
              />
           
              <Route
                path="/patientdashboard"
                element={<PersonalPatientFile />}
              />
              <Route path="blogmainpage" element={<BlogMainPage />} />
              {/* <Route path="webcam" element={<WebCam />} /> */}
              <Route path="blogbydoctor" element={<DoctorBlog />} />
              <Route
                path="doctorregistration"
                element={<DoctorRegistration />}
              />
              <Route
                path="/chat/obesity/"
                element={<Chat user={UserInfo} onlineUsers={onlineUsers} patientUsername = {patientUsername}  />}
              />
              <Route path="/addnewpatient" element={<AddPatient />} />
              <Route
                path="/appointmentlist"
                element={<AppointmentListHomePage />}
              />
              <Route path="/proddetails" element={<ProductDetails />} />
              <Route path="/eventsbyclinic" element={<EventByClinic />} />
              <Route
                path="/clinicdietitianlist"
                element={<ClinicDietitianList />}
              />
              <Route
                path="/clinictrainerlist"
                element={<ClinicTrainerList />}
              />
              <Route path="/doctorcreateblog" element={<DoctorCreateBlog />} />
              <Route
                path="/dietitianregistration"
                element={<DietitianRegistration />}
              />
              <Route path="questionnaire" element={<QuestionnaireNew />} />
              <Route path="adddoctordetails" element={<DoctorExtraDetails />} />
              <Route
                path="adddietitianextradetails"
                element={<DietitianExtraDetails />}
              />
              <Route path="subcliniclist" element={<SubClinicList />} />
              <Route
                path="subclinicdetails"
                element={<SubClinicDetailsHomePage />}
              />
              <Route
                path="subclinicpatients"
                element={<SubClinicPatientList />}
              />
              <Route
                path="subclinicdoctors"
                element={<SubClinicDoctorList />}
              />
              <Route
                path="subclinicreceptionist"
                element={<SubClinicReceptionistList />}
              />
              <Route
                path="subclinicappointmentlist"
                element={<SubClinicAppointmentList />}
              />
              <Route path="docbyclinic" element={<ClinicDocuments />} />
              <Route path="marketingmail" element={<MailHomePage />} />
              <Route
                path="patientviewfordoctor"
                element={<PatientViewForDoctor />}
              />

              <Route path="accsetting" element={<AccountSetting />} />
              <Route path="userdata" element={<UserData />} />
            
              <Route
                path="/termsandconditions"
                element={<TermsandConditions />}
              />
              <Route path="/privacypolicy" element={<PrivacyPolicy />} />
              <Route
                path="/accessibilitypolicy"
                element={<AccessibilityPolicy />}
              />
              <Route path = "/patientresponseanalysis" element = {<PatientResponseAnalysis />} />
              <Route path = "/customersuccess" element = {<CustomerSuccessByClinic />} />
            </Routes>
          </Box>

        </Box>
      </div>
    );
}
